module.exports = __webpack_public_path__ + "874e70d084d5d611017086e405b756db.png";